var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h3',{staticClass:"mb-4 text-center font-medium text-gray-800 dark:text-white",domProps:{"textContent":_vm._s(_vm.$t('home.followInstagram'))}}),_c('div',{staticClass:"elfsight-app-f384d398-d79b-42a4-804a-53c1930dfa32"})])
}
var staticRenderFns = []

export { render, staticRenderFns }